import "./Navbar.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import menuIcon from "../../assets/icons/navbar-menu.svg";
import closeIcon from "../../assets/icons/navbar-close.svg";
import LoginButton from "../Auth/Buttons/LoginButton";
import LogoutButton from "../Auth/Buttons/LogoutButton";
import { useAuth } from "../../context/AuthContext/AuthContext";

function Navbar() {
  const [navbarOpen, setNavbarOpen] = useState<boolean>(false);

  const { isAuthenticated, isAdmin, isSuperAdmin } = useAuth();

  useEffect(() => {
    const navbarMenu: HTMLElement | null = document.getElementById(
      "mobile-menu-container",
    );
    if (navbarMenu) {
      navbarMenu.style.left = navbarOpen ? "0" : "100%";
    }
  }, [navbarOpen]);

  // useEffect(() => {
  //   const navbarMenu = document.getElementById("mobile-menu-container");
  //   if (navbarMenu) {
  //     if (navbarOpen) {
  //       navbarMenu.classList.add("open");
  //       document.body.classList.add("menu-open");
  //     } else {
  //       navbarMenu.classList.remove("open");
  //       document.body.classList.remove("menu-open");
  //     }
  //   }
  // }, [navbarOpen]);

  return (
    <nav className="navbar df fdr aic jcsb">
      <Link
        to="/"
        style={{
          textDecoration: "none",
        }}
      >
        <h1 className="navbar-text gnspen-logo header-logo">GSPEN</h1>
      </Link>
      <div
        className="mobile-menu-button df aic jcc"
        onClick={() => setNavbarOpen((prev) => !prev)}
      >
        {navbarOpen ? (
          <img className="navbar-icon-close" src={closeIcon} alt="close" />
        ) : (
          <img className="navbar-icon-menu" src={menuIcon} alt="menu" />
        )}
        <div
          id="mobile-menu-container"
          className="mobile-menu-container navlinks df fdc aic jcsa"
        >
          <Link to="/blog" className="navlink navbar-text">
            ბლოგი
          </Link>
          <Link to="/calculator" className="navlink navbar-text">
            კალკულატორი
          </Link>
          {isAdmin && (
            <Link to="/dictionary" className="navlink navbar-text">
              პარამეტრები
            </Link>
          )}
          {isSuperAdmin && (
            <Link to="/user-management" className="navlink navbar-text">
              იუზერები
            </Link>
          )}
          {!isAuthenticated ? <LoginButton /> : <LogoutButton />}
        </div>
      </div>
      <div
        id="desktop-menu-container"
        className="desktop-menu-container navlinks df fdr aic jcsb"
      >
        <Link to="/blog" className="navlink navbar-text">
          ბლოგი
        </Link>
        <Link to="/calculator" className="navlink navbar-text">
          კალკულატორი
        </Link>
        {isAdmin && (
          <Link to="/dictionary" className="navlink navbar-text">
            პარამეტრები
          </Link>
        )}
        {isSuperAdmin && (
          <Link to="/user-management" className="navlink navbar-text">
            იუზერები
          </Link>
        )}
        {!isAuthenticated ? <LoginButton /> : <LogoutButton />}
      </div>
    </nav>
  );
}

export default Navbar;
